import { BindingError } from "../BindingError.js";
function assert(arg, message) {
  if (!arg) {
    throw new BindingError(`Assertion fail!${message ? `
${message}` : ""}`);
  }
}
export {
  assert
};
//# sourceMappingURL=assert.js.map
